import moment from 'moment';

export function skacDatetimeFilter(DateManipulationService) {
  'ngInject';
  return function filter(date) {
    return DateManipulationService.formatDatetime(date);
  }
}
